import copyObject from "./_copyObject.js";
import keysIn from "./keysIn.js";
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}
export {
  toPlainObject as default
};
//# sourceMappingURL=toPlainObject.js.map
